/**
 * Contains all the data points related Premium Dashboard premium support option
 */
export default {
    PremiumDashContactPremiumSupport: {
        datapoint: {
            name: 'PremiumDashContactPremiumSupport',
            options: { isCore: true },
        },
    },
};
